export const passValidations = {
    annual: {
        label: "Annual Pass",
        regex: "^\\d{2}1\\d{6}$"
    },
    senior: {
        label: "Senior Pass",
        regex: "^\\d{2}2\\d{6}$"
    },
    access: {
        label: "Access Pass",
        regex: "^\\d{2}3\\d{6}$"
    },
    military: {
        label: "Military Pass",
        regex: "^.*$"
    }
};
